import React from 'react'
import { Grid, Typography, Divider } from '@mui/material'
import Masonry from '@mui/lab/Masonry';
import '../../../styles/report.css'
import DynamicComponent from '../DynamicComponent'

/** 
 * 
 * This component is expecting the following input. 
{
    "Order": "60",
    "Visible": "1",
    "Label": "Health Assessment Responses",
    "ComponentType": "STANDARD MASONRY SECTION",
    "Sections": [
        {
            "ComponentType": "MUST BE DYNAMIC COMPONENT"
        }
    ]
}
        
*/

const MasonrySectionNoBG = (props) => {

    const OrderedSections = [...props.component.ComponentValues].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })
    const FilteredSections = OrderedSections.filter((a)=> { return a.Visible==='1' })

    return (
        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ padding: '10px' }}>
            
                <Grid item xs={12}>
                    <Typography variant="h4" align="center">{props.component.Label}</Typography>
                </Grid>
                <Grid item xs={12} m={1}>
                    <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                </Grid>
                <Grid item xs={12}>
                    <Masonry columns={{xs:1, sm:2, md:3}} spacing={1} >

                        {
                            FilteredSections && FilteredSections.map((displayValues, index) => {
                                return (
                                    <DynamicComponent component={displayValues} key={index} elevationdisabled={props.elevationdisabled === true ? true : false}/>
                                )
                            })
                        }
                    </Masonry>
                </Grid>
            
        </Grid>
    )
}

export default MasonrySectionNoBG